"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var React = require("react");
var causalityTable_1 = require("./causalityTable");
var causalityListToolbar_1 = require("./causalityListToolbar");
var App_1 = require("../../../App");
var urls_1 = require("../../../urls");
var contexts_1 = require("../../../interfaces/contexts");
var CausalityList = (function (_super) {
    __extends(CausalityList, _super);
    function CausalityList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickHandler = function (event, url) {
            window.location.href = url;
        };
        _this.onClickExportToExcel = function (event) {
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                var url_name = _this.props.is_cause ?
                    urls_1.Urls.cause_excel :
                    urls_1.Urls.effect_excel;
                var url = (0, urls_1.resolve)(url_name, context.project) + window.location.search;
                spinnerStart();
                poll_for_result(url, {}, function () {
                    $('div.load_indicator span#finished').html("0");
                    $('div.load_indicator span#max').html("1");
                }, function (data) {
                }, function () {
                    spinnerStop();
                }, function (errorThrown) {
                    notification(errorThrown, { type: "error" });
                    spinnerStop();
                });
            }
            else {
                throw new Error("Cannot export to Excel in this context");
            }
        };
        return _this;
    }
    CausalityList.prototype.render = function () {
        var data = this.props.is_cause ?
            App_1.store.causalitylist.causes.data :
            App_1.store.causalitylist.effects.data;
        var dialogState = this.props.is_cause ?
            App_1.store.causeDialog :
            App_1.store.effectDialog;
        return (React.createElement("div", { className: "CausalityList" },
            React.createElement("div", { className: "Div--Background rounded px-3 pb-4 pt-1" },
                React.createElement(causalityListToolbar_1.default, { is_cause: this.props.is_cause, rows_counter: data.paginator.items, has_business_model: data.has_business_model, clickExportHandler: this.onClickExportToExcel }),
                React.createElement(causalityTable_1.default, { is_cause: this.props.is_cause, dialogState: dialogState }))));
    };
    CausalityList = __decorate([
        mobx_react_1.observer
    ], CausalityList);
    return CausalityList;
}(React.Component));
exports.default = CausalityList;
